import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ChatComponent} from './chat/chat.component';
import {UserPermissionsService} from '@global/services/user-permissions.service';
import {NavigationStart, Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class ArtificialIntelligenceService {
    private chatDialogRef: MatDialogRef<ChatComponent> | null = null;

    private readonly dialogPosition = {left: '11.8%', top: '7.5%'};

    constructor(
        private dialog: MatDialog,
        private userPermissions: UserPermissionsService,
        private router: Router,
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.closeChat();
            }
        });
    }

    startChat(entityId: number, entityType: 'institution' | 'person'): void {
        const hasPermission =
            entityType === 'institution'
                ? !!this.userPermissions.getPermissionValue('enableAiChatInstitutionsButton')
                : !!this.userPermissions.getPermissionValue('enableAiChatPeopleButton');

        if (!hasPermission || !entityId || entityId <= 0) {
            return;
        }

        // Toggle behavior (second click closes)
        if (this.chatDialogRef) {
            this.closeChat();
            return;
        }

        this.chatDialogRef = this.dialog.open(ChatComponent, {
            data: {entityId, entityType},
            panelClass: 'ai-chat-dialog',
            hasBackdrop: false,
            disableClose: true,
            closeOnNavigation: false,
            minWidth: '320px',
            minHeight: '320px',
            maxWidth: 'none',
            maxHeight: 'none',
            position: this.dialogPosition,
            enterAnimationDuration: '0ms',
            exitAnimationDuration: '150ms',
        });
        this.chatDialogRef.afterClosed().subscribe(() => {
            this.chatDialogRef = null;
        });
    }

    closeChat(): void {
        if (this.chatDialogRef) {
            this.chatDialogRef.close();
            this.chatDialogRef = null;
        }
    }
}
